import { render, staticRenderFns } from "./PlanfeedDetail.vue?vue&type=template&id=7b3de9d8&lang=pug&"
import script from "./PlanfeedDetail.vue?vue&type=script&lang=js&"
export * from "./PlanfeedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports